import { v4 } from "uuid";

import { OrganizationPageView } from "@/canvas/features/OrganizationPage/OrganizationPageView";
import { addCacheTagHeaderToServerResponse } from "@/common/helpers/cache";
import { getSSROrganizationPage, getTranslation } from "@/common/helpers/getStaticProps";
import { usePinnedPageProps } from "@/common/hooks/usePinnedPageProps";
import { ServerSideContext } from "@/common/types/app";
import { OrganizationPageOutput } from "@/common/types/trpc";
import { OrganizationPageHead } from "@/components/Head/OrganizationPageHead/OrganizationPageHead";

type OrganizationPagePropsType = {
  organizationPage: OrganizationPageOutput;
};

const OrganizationPageComponent = (pageProps: OrganizationPagePropsType) => {
  const { organizationPage } = usePinnedPageProps(pageProps);

  return (
    <OrganizationPageView
      organizationPage={organizationPage}
      head={<OrganizationPageHead organizationPage={organizationPage} />}
    />
  );
};

export const getServerSideProps = async (context: ServerSideContext<{ organizationId: string }>) => {
  const requestId = (context.req?.headers?.["x-request-id"] as string) || v4();
  const { organizationId } = context.params;

  addCacheTagHeaderToServerResponse(context.res, organizationId);

  try {
    const [organizationPageResponse, translations] = await Promise.all([
      getSSROrganizationPage({ organizationIdOrUrlPath: organizationId, requestId }),
      getTranslation(context.locale, ["common", "organization"]),
    ]);
    return {
      props: {
        ...translations,
        organizationPage: organizationPageResponse,
      },
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(
      `NEXT_ERROR: request failed - redirecting to notFound organizationIdOrUrlPath=${organizationId} ssrId=${requestId}`,
      error
    );
    return { props: {}, notFound: true };
  }
};

export default OrganizationPageComponent;
